import { Component, input, output } from "@angular/core";
import { VdsIconButtonComponent } from "@dcc/vestas-design-system/angular/components/button";
import { VdsIconComponent } from "@dcc/vestas-design-system/angular/components/icon";
import { PolymorpheusContent, PolymorpheusOutlet } from "@taiga-ui/polymorpheus";

@Component({
    selector: "vds-main-nav",
    templateUrl: "./main-nav.component.html",
    styleUrl: "./main-nav.component.css",
    imports: [VdsIconComponent, VdsIconButtonComponent, PolymorpheusOutlet]
})
export class MainNavComponent {
    title = input<PolymorpheusContent<never> | undefined>(undefined);
    // eslint-disable-next-line @angular-eslint/no-output-native
    close = output<void>();
}
